
import { createRoot } from "react-dom/client";
import AppRouter from "./AppRouter.tsx";
import "./index.css";
import { initSentry } from "./config/sentry";

// Initialize Sentry before rendering the app
initSentry();

createRoot(document.getElementById("root")!).render(<AppRouter />);
  